import { AppPermissions, useHasPermission, Dict } from "../core";

export const checkPermission = (code: string, apiPermissions?: Dict) => {
  const canScheduleTestDrive =
    apiPermissions?.[AppPermissions.ScheduleTestDrive];

  const canRequestCallBack = apiPermissions?.[AppPermissions.RequestCallBack];
  const canAddVehicleToLead = apiPermissions?.[AppPermissions.AddVehicleToLead];

  const canScheduleShowroomVisit =
    apiPermissions?.[AppPermissions.ScheduleShowroomVisit];
  const canConvertToEnquiry = apiPermissions?.[AppPermissions.ConvertToEnquiry];
  const canCreateLeadActivity =
    apiPermissions?.[AppPermissions.CreateLeadActivity];

  const canReserveTime = apiPermissions?.[AppPermissions.ReserveTime];
  const canCreateRequirement =
    apiPermissions?.[AppPermissions.CreateRequirement];
  const canMergeLeads =
    apiPermissions?.[AppPermissions.MergeLeads];
  const canMergeCustomer =
  apiPermissions?.[AppPermissions.MergeCustomers];
  const canMergeCompany =
  apiPermissions?.[AppPermissions.MergeCompany];
  
  switch (code) {
    case "scheduleATestDrive":
      return canScheduleTestDrive;
    case "requestACallBack":
      return canRequestCallBack;
    case "addANewVehicle":
      return canAddVehicleToLead;
    case "scheduleAShowroomVisit":
      return canScheduleShowroomVisit;
    case "convertAsEnquiry":
      return canConvertToEnquiry;
    case "call":
      return canCreateLeadActivity;
    case "timeOff":
      return canReserveTime;
    case "vehicleTimeOff":
      return canReserveTime;
    case "addNewRequirement":
      return canCreateRequirement;
    case "mergeLeads":
      return canMergeLeads;
    case "mergeCustomer":
      return canMergeCustomer;
    case "mergeCompany":
      return canMergeCompany;
    default:
      return true;
  }
};
